import { forwardRef } from 'react';
import { ReactComponent as Jersey } from '../../Assets/jersey.svg';
import Text from '../Text';
import AvatarWrapper from './style/avatarWrapper';

const Avatar = forwardRef((props, ref) => {
  const { lastName } = props;
  const formattedLastName = lastName.length > 8 ? `${lastName.slice(0, 8)}.` : lastName;

  return (
    <AvatarWrapper ref={ref}>
      <Jersey className='jersey-icon' />
      <Text size='SM' className='last-name'>
        {formattedLastName}
      </Text>
      <Text size='MD' className='shirt-number'>
        10
      </Text>
    </AvatarWrapper>
  );
});

Avatar.displayName = 'Avatar';
export default Avatar;
